export const DEFAULT_TITLE_STYLES = 'text-2xl font-semibold leading-8';